import { CheckSVG, CopySVG } from '@media/svgs'
import { useCopyToClipboard } from '@hooks/useCopyToClipboard'

// A read-only verification value: label top-left, copy control top-right, the
// value below in a monospace block.
//
// The value is rendered in FULL and is user-selectable — it is the raw material a
// player re-runs the maths on, so it is only ever wrapped, never truncated. Copy
// writes the value byte-for-byte: no trimming, no case changes, no reformatting.
const HashValue = ({ label, value, placeholder = '—', multiline = true }) => {
  const { copy, isCopied } = useCopyToClipboard()
  const copied = isCopied(value)

  return (
    <div className="standard-normal-provably-fair-hash">
      <div className="standard-normal-provably-fair-hash-header">
        <span className="standard-normal-provably-fair-hash-label">{label}</span>

        {value && (
          <button
            type="button"
            className={`standard-normal-provably-fair-copy ${copied ? 'is-copied' : ''}`}
            onClick={() => copy(value)}
            aria-label={copied ? `${label} copied` : `Copy ${label}`}
            title={copied ? 'Copied' : 'Copy'}
          >
            {copied ? <CheckSVG /> : <CopySVG />}
          </button>
        )}
      </div>

      <code
        className={`standard-normal-provably-fair-hash-value ${value ? '' : 'is-empty'} ${
          multiline ? '' : 'is-single-line'
        }`}
        title={value ?? placeholder}
      >
        {value ?? placeholder}
      </code>
    </div>
  )
}

export default HashValue
